// @flow

export const ReactSelect = {
  control: (provided: any, state: any) => {
    return {
      ...provided,
      width: '195px',
      fontSize: '17px',
      fontWeight: 'bold',
      borderRadius: '2px',
      boxShadow: 'none',
      border: 'none',
      borderBottom: '1px solid #CACACA',
      height: '31px',
      marginLeft: '10px',
      ':hover, :active': {
        borderColor: '#ECECEC',
        boxShadow: 'none'
      }
    };
  },
  menu: (provided: any, state: any) => {
    return {
      ...provided,
      zIndex: 2
    };
  },
  menuList: (provided: any, state: any) => {
    return {
      ...provided,
      padding: 0,
      maxHeight: 152
    };
  },
  option: (provided: any, state: any) => {
    return {
      cursor: 'pointer',
      display: 'block',
      padding: '8px 12px',
      borderRadius: '2px',
      userSelect: 'none',
      textAlign: 'left',
      backgroundColor: state.isSelected
        ? '#278C7E'
        : state.isFocused
        ? '#D9E7E4'
        : '#FFF',
      color: state.isSelected ? 'white' : '#333',
      ':hover': {
        backgroundColor: state.isSelected ? '#278C7E' : '#D9E7E4',
        color: state.isSelected ? 'white' : '#333'
      }
    };
  },
  dropdownIndicator: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#333',
      transition: 'all .2s ease',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
      ':hover': {
        color: '#333'
      }
    };
  },
  indicatorSeparator: () => ({
    display: 'none'
  })
};

export const SelectCurrencies = {
  control: (provided: any, state: any) => {
    return {
      ...provided,
      width: '78px',
      fontSize: '13px',
      color: '#555555',
      borderRadius: '2px',
      boxShadow: 'none',
      border: 'none',
      height: '31px',
      background: 'none',
      marginLeft: '10px',
      ':hover, :active': {
        borderColor: '#ECECEC',
        boxShadow: 'none'
      }
    };
  },
  menu: (provided: any, state: any) => {
    return {
      ...provided,
      zIndex: 2
    };
  },
  menuList: (provided: any, state: any) => {
    return {
      ...provided,
      padding: 0,
      maxHeight: 152
    };
  },
  option: (provided: any, state: any) => {
    return {
      cursor: 'pointer',
      display: 'block',
      padding: '8px 12px',
      borderRadius: '2px',
      userSelect: 'none',
      textAlign: 'left',
      backgroundColor: state.isSelected
        ? '#278C7E'
        : state.isFocused
        ? '#D9E7E4'
        : '#FFF',
      color: state.isSelected ? 'white' : '#333',
      ':hover': {
        backgroundColor: state.isSelected ? '#278C7E' : '#D9E7E4',
        color: state.isSelected ? 'white' : '#333'
      }
    };
  },
  dropdownIndicator: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#333',
      transition: 'all .2s ease',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
      ':hover': {
        color: '#333'
      }
    };
  },
  indicatorSeparator: () => ({
    display: 'none'
  })
};

export const getCustomStyle = (hasError: boolean): any => {
  return {
    control: (provided: any, state: any) => {
      return {
        ...provided,
        borderRadius: '2px',
        borderColor: hasError ? '#dc3545' : '#ececec',
        boxShadow: 'none',
        ':hover, :active': {
          borderColor: hasError ? '#dc3545' : '#ececec'
        }
      };
    },
    menuList: (provided: any, state: any) => {
      return {
        ...provided,
        padding: 0,
        maxHeight: 152
      };
    },
    placeholder: (provided: any, state: any) => {
      return {
        ...provided,
        color: '#4A4A4A',
        fontSize: '16px',
        lineHeight: '19px'
      };
    },
    option: (provided: any, state: any) => {
      return {
        cursor: 'pointer',
        display: 'block',
        padding: '8px 12px',
        borderRadius: '2px',
        userSelect: 'none',
        textAlign: 'left',
        backgroundColor:
          state.isSelected && !state.isDisabled
            ? '#278C7E'
            : state.isFocused
            ? '#D9E7E4'
            : '#FFF',
        color:
          state.isSelected && !state.isDisabled
            ? '#FFFFFF'
            : state.isDisabled
            ? '#ccc'
            : '#4A4A4A',
        ':hover': {
          backgroundColor: state.isDisabled
            ? '#FFF'
            : state.isSelected
            ? '#278C7E'
            : '#D9E7E4',
          color: state.isDisabled
            ? '#ccc'
            : state.isSelected
            ? '#FFFFFF'
            : '#333'
        }
      };
    },
    dropdownIndicator: (provided: any, state: any) => {
      return {
        ...provided,
        color: 'gray',
        transition: 'all .2s ease',
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
        ':hover': {
          color: '#333'
        }
      };
    },
    indicatorSeparator: () => ({
      display: 'none'
    })
  };
};
